// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

export interface endExamRequestPayload {
  id: number;
  choosedAnswer: any;
  callback?: Function;
}
export interface endExamSuccessPayload {}

export interface endExamFailPayload {
  error: Error;
}

export const endExamActions = createAsyncAction(
  'elearning/END_EXAM',
  'elearning/END_EXAM_SUCCESS',
  'elearning/END_EXAM_FAIL'
)<
  endExamRequestPayload,
  endExamSuccessPayload,
  endExamFailPayload
>();
